import CacheStorage from "../../../service/storage/CacheStorage";
import StorageKeys from "../../../const/StorageKeys";
import LoginProvider from "../../onboarding/login/LoginProvider";
import ApiUrls from "../../../service/api/ApiUrls";
import ApiService from "../../../service/api/ApiService";
import { SettingsPersonalInfoModel } from "../../../model/settings/SettingsPersonalInfoModel";
import { navigate } from "../../../service/navigation/Navigation";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import ShowToast from "../../../widget/common/ui/Toast";

const SettingsPersonalProfileProvider =
  new (class SettingsPersonalProfileProvider {
    navigate = (url: string) => {
      if (UtilityHelper.isNotEmpty(url)) {
        navigate(url);
      }
    };

    logout = () => {
      LoginProvider.logout();
    };

    getProfileAPI = async (): Promise<SettingsPersonalInfoModel | null> => {
      ApiUrls.init();

      const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
      const url: string = `${ApiUrls.baseUrl}profile/get_personal_details`;
      const body: any = {
        account_id: accountId,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          const settingsPersonalInfoModel: SettingsPersonalInfoModel = response;
          return settingsPersonalInfoModel;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return null;
    };

    updateProfileAPI = async (params: {
      firstName: string;
      lastname: string;
      mobileCodeId: string;
      mobile: string;
      cityId: string;
    }): Promise<boolean> => {
      ApiUrls.init();

      const accountId: string = CacheStorage.getValue(StorageKeys.account_id);
      const url: string = `${ApiUrls.baseUrl}profile/update_personal_details`;
      const body: any = {
        account_id: accountId,
        first_name: params.firstName,
        last_name: params.lastname,
        mobile_code_id: params.mobileCodeId,
        mobile_no: params.mobile,
        city_id: params.cityId,
      };

      const response: any = await ApiService.postApi(url, body);
      if (response != null) {
        if (response["success"] === "1") {
          return true;
        } else {
          ShowToast.error(response["errorMessage"]);
        }
      }

      return false;
    };
  })();

export default SettingsPersonalProfileProvider;
